/* 
 * Vue js extend
 */

module.exports = ( Vue ) => { 

	Vue.prototype.user = false;

	Vue.prototype.setUser = function( usr ) {
		if( typeof usr == 'object' ) {
			Vue.prototype.user = usr;
		}
	}

	Vue.prototype.url = function( to ) {
		var base = "/";

		if( typeof to == 'undefined' ) {
			return base;
		} else {
			return base + to;
		}
	}

	
}
